/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import INetworkNode = Models.INetworkNode;
    import IBlockName = Models.IBlockName;
    import NetworkNode = Models.NetworkNode;
    import NetworkNodeType = Models.NetworkNodeType;
    import IGateway = Models.IGateway;
    import IFlexEvent = Models.IFlexEvent;
    import GeoElement = Models.GeoElement;
    import IPaginatedList = Models.IPaginatedList;
    import INetworkInterface = Models.INetworkInterface;
    import IFilterDirectiveMap = Directives.IFilterDirectiveMap;
    import INetwork = Models.INetwork;
    import Network = Models.Network;
    import Gateway = Models.Gateway;
    import IEvaluatedAcl = Models.IEvaluatedAcl;
    import IVno = Models.Vno;
    import NetworkInterface = Application.Models.NetworkInterface;
    import Block = Models.IBlock
    import IBlock = Application.Models.IBlock;
    import IBlockConnections = Application.Models.IBlockConnections;
    import IBlockNameParameters = Models.IBlockNameParameters;
    import IStreamPipe = Models.IStreamPipe;
    import IBlockTypeConnectionType = Models.IBlockTypeConnectionType;
    import Digicon = Application.Models.Digicon;
    import IDigicon = Application.Models.IDigicon;
    import IKit = Application.Models.IKit;
    import IPromise = angular.IPromise;
    import BlockTypeNaturalKey = Application.Models.BlockTypeNaturalKey;
    import Utils = Common.Utils;

    interface IOffsettedRepo {
        totalLoaded: number;
        firstLoadFinished: boolean;
        loading: boolean;
    }

    interface IExtendedInvetoryElement {
        vnosToPrint?: string;
        evaluatedPermissions?: IEvaluatedAcl;
    }

    export interface INodeWizardResponse {
        networkNode: NetworkNode;
        new: boolean;
    }

    interface IAdminInventoryControllerRouteParamsService extends ng.route.IRouteParamsService {
        type: string;
    }

    type IGatewayExtended = (IGateway & IExtendedInvetoryElement);
    type INetworkExtended = (INetwork & IExtendedInvetoryElement);
    type INetworkNodeExtended = (INetworkNode & IExtendedInvetoryElement);

    export class AdminInventoryController {
        public digiconsReady: boolean = false;
        public static NUM_REQUESTS: number = 30;
        public static $name: string = "adminInventoryController";
        public static $inject: string[] = ['networkNodeService',
                                           '$routeParams',
                                           'networkNodeTypeService',
                                           'ModalService',
                                           'networkService',
                                           'gatewayService',
                                           'stompService',
                                           '$scope',
                                           '$timeout',
                                           'healthService',
                                           'vnoService',
                                           'blockService',
                                           'messageTranslationsService',
                                           '$window',
                                           'userService',
                                           'aclService',
                                           'streamPipeService',
                                           'digiconService',
                                           '$interval',
                                           'backendConfigService',
                                           'deviceCredentialsService',
        ];

        public networkNodes: INetworkNodeExtended[];
        public allSrtNetworkNodes: NetworkNode[];
        public searchResults: string[];
        public networkNodeTypes: NetworkNodeType[];
        public gateways: IGatewayExtended[];
        public digicons: IDigicon[];
        public networks: INetworkExtended[];
        public addedNodes: INetworkNodeExtended[];

        public selectingElements: boolean;

        public mags: NetworkNode[];
        public currentUser: Models.User;
        public isDemiurgo: boolean;
        public userIsAdmin: boolean;
        public digiconInterval: IPromise<any>;

        public typeFilterMap: IFilterDirectiveMap; // for column-filter directive
        public statusFilterMap: IFilterDirectiveMap; // for column-filter directive
        public vnoFilterMap: IFilterDirectiveMap; // for column-filter directive
        public maintenanceFilterMap: IFilterDirectiveMap; // for column-filter directive
        public digiconMatchDayFilterMap: IFilterDirectiveMap; // for column-filter directive
        public digiconModeFilterMap: IFilterDirectiveMap; // for column-filter directive
        public digiconPortFilterMap: IFilterDirectiveMap; // for column-filter directive

        public digiconRoleFilterMap: IFilterDirectiveMap; // for column-filter directive
        public digiconMatchNumberFilterMap: IFilterDirectiveMap; // for column-filter directive
        public digiconStatusFilterMap: IFilterDirectiveMap; // for column-filter directive
        public digiconMainGatewayFilterMap: IFilterDirectiveMap; // for column-filter directive
        public digiconBackupGatewayFilterMap: IFilterDirectiveMap; // for column-filter directive
        public digiconKitsFilterMap: IFilterDirectiveMap; // for column-filter directive




        private currentPage: number;
        private moreData: boolean;
        private moreDataLoaded: boolean; // tslint:disable-line:no-unused-variable // used in html
        private dataLoaded: boolean; // tslint:disable-line:no-unused-variable // used in html
        private srtLoaded: boolean;

        private sortType: string;
        private sortReverse: string;
        private searchText: string;

        private timeoutSearch: ng.IPromise<void>;
        private subscription: Services.IEventSubscription;

        private nodesRepo: IOffsettedRepo = {
            totalLoaded: 0,
            firstLoadFinished: false,
            loading: true,
        };

        private maintenanceFilterName: string = "Maintenance";
        private operationFilterName: string = "Operation";

        private searchTextForHighlight: string;

        private nodeType: string;

        private vnos: IVno[];

        private SERIAL_NUMBER_ERROR: string = "could not execute statement; SQL [n/a]; constraint [network_node_mft_serial_number_unique]";

        private DIGICON_INTERVAL: number = 60000;


        private hasDigicon: Boolean = false;
        private searchTextRegExp: RegExp;
        private escapedSearchText: string;
        private findSrtText: string;

        /**
         * Constructor of the class.
         */
        constructor(private networkNodeService: Services.NetworkNodeService,
                    private $routeParams: IAdminInventoryControllerRouteParamsService,
                    private networkNodeTypeService: Services.NetworkNodeTypeService,
                    private modalService: ngModal.IModalService,
                    private networkService: Services.NetworkService,
                    private gatewayService: Services.GatewayService,
                    private stompService: Services.StompService,
                    private $scope: ng.IScope,
                    private $timeout: ng.ITimeoutService,
                    private healthService: Services.HealthService,
                    private vnoService: Services.VnoService,
                    private blockService: Services.BlockService,                    
                    private messageTranslationsService: Services.MessageTranslationsService,
                    private $window: ng.IWindowService,
                    private userService: Services.UserService,
                    private aclService: Services.AclService,
                    private streamPipeService: Services.StreamPipeService,
                    private digiconService: Services.DigiconService,
                    private $interval: ng.IIntervalService,
                    private backendConfigService: Services.BackendConfigService,
                    private deviceCredentialsService: Services.DeviceCredentialsService) {
            this.nodeType = this.$routeParams.type ? this.$routeParams.type : 'devices';
            this.srtLoaded = false;

            this.initSubscriptions();
            this.initVariables().then(() => {
                this.initData();
                this.getDigiconIp();
            });
        }

        private async getDigiconIp(): Promise<void>{
            this.hasDigicon = await this.backendConfigService.hasDigicon();
        }

        public applyFilter(): void {
            this.networkNodes = [];
            this.currentPage = 0;
            this.addedNodes = [];
            if (this.nodeType === 'devices') {
                this.loadNetworkNodes();
            }
            if (this.nodeType === 'networks') {
                this.loadNetworks();
            }
            if (this.nodeType === 'gateways') {
                this.loadGateways();
            }
            if (this.nodeType === 'digicon') {
                this.loadDigicons();
            }
            this.searchTextForHighlight = this.searchText;
            this.escapedSearchText = Utils.regExpEscape(this.searchTextForHighlight);
            this.searchTextRegExp = new RegExp(this.escapedSearchText, "ig");
        }

        public clearFilters(): void {
            this.searchText = "";
            this.addedNodes = [];
            this.applyFilter();
        }

        public sortColumn(type: string): void {
            this.sortType = type;
            this.sortReverse = this.sortReverse === 'ASC' ? 'DESC' : 'ASC';
            this.addedNodes = [];
            this.applyFilter();
        }

        public searchByText(): void {
            this.$timeout.cancel(this.timeoutSearch);
            this.addedNodes = [];
            this.applyFilter();
        }

        public searchAsType(): void {
            if (this.searchText !== undefined) {
                this.$timeout.cancel(this.timeoutSearch);
                this.timeoutSearch = this.$timeout(() => {
                    this.addedNodes = [];
                    this.applyFilter();
                }, 500);
            }
        }

        public findSrtUrl(){
            if(this.findSrtText.length == 0) { this.searchResults = []; return; };
 
            this.searchResults = []; // Clear previous results

            let matchedBlocks: { [key: number]: string } = {};
            this.allSrtNetworkNodes.forEach((node: NetworkNode) => {
                if(node.blocks){
                    node.blocks.forEach((block: IBlock) => {
                        block.blockConnections.forEach((blockConnection: IBlockConnections) => {
                            if(blockConnection.parameters.url){
                                if(blockConnection.parameters.url.indexOf(this.findSrtText) !== -1){
                                    matchedBlocks[block.id] = block.name;
                                }
                            }
                        });
                     });
                }
            });

        this.streamPipeService.getStreamPipesByBlockList(Object.keys(matchedBlocks).map(Number)).then((streamPipes: IStreamPipe[][]) => {
            streamPipes = streamPipes.filter((streamPipe: IStreamPipe[]) => streamPipe.length > 0);
            streamPipes.forEach((streamPipe: IStreamPipe[]) => {
                this.searchResults.push(" <a href='/#!/stream/" + streamPipe[0].href.split("/").pop() + "'>" + matchedBlocks[streamPipe[0].sinkBlockId] +" </a>");
            });
        });
        }

        public hasHighlightedBlocks(blocks: Models.IBlock[]): boolean {
            if (blocks === undefined || blocks.length === 0 ||
                this.searchTextForHighlight === undefined || this.searchTextForHighlight === "") {
                return false;
            }

            for (let block of blocks) {
                if (this.searchTextRegExp.test(block.name) !== null) // tslint:disable-line
                    return true;
            }
            return false;
        }

        public selectNodes(): void {
            this.selectingElements = true;
            this.loadAllNodes();
        }

        public selectAllNodes(): void {
            let elements: HTMLInputElement[] = (<HTMLInputElement[]><any> document.getElementsByName("select-node"));
            for (let i = 0; i < elements.length; i++) {
                elements[i].checked = true;
            }
        }

        public selectNoneNodes(): void {
            let elements: HTMLInputElement[] = (<HTMLInputElement[]><any> document.getElementsByName("select-node"));
            for (let i = 0; i < elements.length; i++) {
                elements[i].checked = false;
            }
        }

        public cancelSelectNodes(): void {
            this.selectingElements = false;
        }



        /**
         * This creates a file in memory to be downloaded by the browser from the NetworkNode,
         * some information is filtered from the object because it is not required in the export file, like vnos, connections, etc,...
         */
        public async exportNodes(): Promise<void> {

            let fileName: string;
            let nodesSelected: INetworkNode[] = await Promise.all(this.networkNodes
                .filter(n => (<HTMLInputElement> document.getElementById("select-node-" + n.id)).checked  )
                // Cleanup the export document;
                .map( a => this.transformNodeToExport(a) ));

            if (nodesSelected.length === 0) {
                this.showModalError("Error while exporting ", "You must select at least one node to be exported");
                this.selectingElements = false;
                return;
            }
            // get name for exported file
            fileName = this.getFileName(nodesSelected);

            // this method to download the file might have size limitations
            const dataStr: string = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(nodesSelected, undefined, 2));

            const exportButtonElem: HTMLElement = document.getElementById('export-nodes-file');
            exportButtonElem.setAttribute("href",     dataStr     );
            exportButtonElem.setAttribute("download", fileName);
            exportButtonElem.click();

            this.selectingElements = false;
        }

        public getFileName(nodesSelected: INetworkNode[]): string{

            let now = new Date();
            let fileName: string = now.getDate() + "-" + (now.getMonth() + 1) + "-" + now.getFullYear() +
                "-" + now.getHours() + "-" + now.getMinutes();

            if (nodesSelected.length === 1) {
                fileName =  fileName + "_" + nodesSelected[0].name + ".json";
            } else {
                fileName = fileName + ".json";
            }

            return fileName;
        }

        public importNodes(): void {
            let fileinput: HTMLInputElement = <HTMLInputElement> document.getElementById('fileImport');
            fileinput.click();
            let self: AdminInventoryController = this;

            // because ng-change does not work in this angular version :-(
            fileinput.addEventListener('change', function() {
                let f: File = (<HTMLInputElement> fileinput).files[0];
                let r: FileReader = new FileReader();
                r.onloadend = (event: Event) =>  {
                    let data: any = r.result;
                    let nodesToImport: Models.NetworkNode[] = [];
                    try {
                         nodesToImport = JSON.parse(data);
                    } catch (e) {
                        self.showModalError("Error parsin file", "File is not a valid JSON: " + e)
                        return;
                    }
                    let tasks: Promise<Models.NetworkNode>[] = [];

                    nodesToImport.forEach(node => {
                        node.config.blockNames.generatedBlockNames.forEach(block => {
                            block.lockedName = true;
                        });
                        tasks.push(self.networkNodeService.saveNetworkNode(node));
                    });

                    // the pattern p => p.catch is used to execute ALL the promises, not stoping in the rejecteds
                    Promise.all(tasks.map(p => p.catch(e => e)))
                        .then((e) => self.handlerSaveNodeTask(e))
                        .catch(err =>
                            self.showModalError("Error while importing", "Unexpected error: " + err)
                        );
                };
                r.readAsBinaryString(f);

                // this is required to upload a file with the same name two consecutive times
                fileinput.value = '';
            });
        }

        public launchNetworkNodeWizardModal(element?: INetworkNode, isAdded: boolean = false): void {
            let node: INetworkNode = element ? Common.Utils.clone(element) as INetworkNode : NetworkNode.Empty();
            if (node.geoElement === undefined) node.geoElement = new GeoElement();
            if (node.geoElement.auto === undefined) node.geoElement.auto = true;
            this.modalService.showModal({
                templateUrl: Controllers.NetworkNodeModalController.templateUrl,
                controller: Controllers.NetworkNodeModalController.$name,
                inputs: {
                    node: node,
                    nodeTypes: this.networkNodeTypes,
                    gateways: this.gateways,
                    mags: this.mags,
                    initialStep: undefined,
                    internet: undefined,
                    deviceGuiUrl: undefined,
                    deviceGuiUrlNoProxy: undefined,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.NetworkNodeModalController.ID,
                                                                {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: INodeWizardResponse) => {
                    if (result !== undefined) {
                        this.setNodePermissions([result.networkNode]).then(() => {
                            this.setNetworkNodeExtraData(result.networkNode);
                            this.initNetworkNodes().then(() => {
                                this.setBlocksToShow(result.networkNode);
                                if (result.new) {
                                    this.addedNodes.unshift(result.networkNode);
                                } else {
                                    const i: number = !isAdded ? this.findNetworkNodeIndexByHref(result.networkNode.href) : 
                                                                 this.findNetworkNodeIndexByHref(result.networkNode.href, this.addedNodes);
                                    if (i !== undefined) {
                                        if (!isAdded)
                                            this.networkNodes[i] = result.networkNode;
                                        else   
                                            this.addedNodes[i] = result.networkNode;
                                    }
                                }
                            });
                        });
                    }
                    modalElem.hide();
                }).catch((reason: any) => { // tslint:disable-line
                    modalElem.hide();
                    Common.Utils.alertOnError(reason);
                });
            });
        }

        public launchJsonFormModal(element?: any): void {
            let copy: any = element ? Common.Utils.clone(element) : {};
            this.modalService.showModal({
                templateUrl: Controllers.JsonModalController.templateURL, 
                controller: Controllers.JsonModalController.$name,
                inputs: {
                    data: copy, 
                },
            }).then((modal: ngModal.IModalObject) => {
                let jsonModalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.JsonModalController.ID, {
                    bgclose: false,
                    modal: false,
                    keyboard: false
                });
                jsonModalElem.show();
                modal.close.then((result: any) => {
                    jsonModalElem.hide();
                }
                ).catch((reason: any) => { // tslint:disable-line
                    jsonModalElem.hide();
                    Common.Utils.alertOnError(reason);
                });
                
            }).catch((error: any) => {
                console.error('Error opening modal:', error);
            });
        }

        public launchNetworkModal(element?: INetwork): void {
            let copy: Models.INetwork = element ? Common.Utils.clone(element) as Models.INetwork : Network.Empty();
            this.modalService.showModal({
                templateUrl: Application.Controllers.NetworkModalController.templateUrl,
                controller: Application.Controllers.NetworkModalController.$name,
                inputs: {
                    network: copy,
                },
            }).then((modal: ngModal.IModalObject) => {
                    let networkModalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.NetworkModalController.ID,
                        {bgclose: false, modal: false, keyboard: false});
                    networkModalElem.show();
                    modal.close.then((result: Models.TopologyElement) => {
                        networkModalElem.hide();
                        if (result !== undefined) {
                            this.networkService.saveNetwork(result as Models.INetwork).then((network: Network) => {
                                this.setNetworkPermissions([network]).then(() => {
                                    this.setElementVnos(network);
                                    if (element) {
                                        this.updateNetwork(network);
                                    } else {
                                        this.networks.push(network);
                                    }
                                });
                            });

                        }
                    });
                });
        }

        public launchGatewayModal(element?: IGateway): void {
            let copy: Models.IGateway = element ? Common.Utils.clone(element) as Models.IGateway : Gateway.Empty();
            this.modalService.showModal({
                templateUrl: Application.Controllers.GatewayModalController.templateUrl,
                controller: Application.Controllers.GatewayModalController.$name,
                inputs: {
                    gateway: copy,
                },
            }).then((modal: ngModal.IModalObject) => {
                    let gatewayModalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.GatewayModalController.ID,
                        {bgclose: false, modal: false, keyboard: false});
                    gatewayModalElem.show();
                    modal.close.then((result: Models.TopologyElement) => {
                        gatewayModalElem.hide();
                        if (result !== undefined) {
                            this.gatewayService.saveGateway(result as Models.IGateway).then((gateway: Gateway) => {
                                this.setGatewayPermissions([gateway]).then(() => {
                                    this.setElementVnos(gateway);
                                    if (element) {
                                        this.updateGateway(gateway);
                                    } else {
                                        this.gateways.push(gateway);
                                    }
                                });
                            });
                        }
                    });
                });
        }

        /**
         * modal to add a digicon box
         */
        public launchDigiconModal(element?: IDigicon, duplicate: boolean = false): void {
            let copy: Models.IDigicon = element ? Common.Utils.clone(element) as Models.IDigicon : Digicon.Empty();
            this.modalService.showModal({
                templateUrl: Application.Controllers.DigiconModalController.templateUrl,
                controller: Application.Controllers.DigiconModalController.$name,
                inputs: {
                    digicon: copy,
                    duplicate: duplicate,
                },
            }).then((modal: ngModal.IModalObject) => {
                let digiconModalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.DigiconModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                digiconModalElem.show();
                modal.close.then((result: Models.Digicon) => {
                    digiconModalElem.hide();
                    if (result !== undefined) {
                        if (element && !duplicate) {
                            this.digiconService.updateDigicon(result as Models.IDigicon).then((digicon: Digicon) => {
                                this.loadDigicons();
                            }).catch((reason: ngCustom.IReason) => {
                                this.showErrorModal('Error updating digicon', 'mainGateway or backupGateway already exists.');
                            });
                        }
                        else {
                            this.digiconService.saveDigicon(result as Models.IDigicon).then((digicon: Digicon) => {
                                this.loadDigicons();
                            }).catch((reason: ngCustom.IReason) => {
                                this.showErrorModal('Error updating digicon', 'kit is in use or gateways already exists.');
                            });
                        }

                    }
                });
            });
        }
        
        private async startKit(digicon: IDigicon):Promise<void>{

            this.modalService.showModal({
                templateUrl: Controllers.ConfirmModalController.templateURL,
                controller: Controllers.ConfirmModalController.$name,
                inputs: {
                    title: 'START KIT',
                    description: "Kit will be started",
                    name: digicon.kit,
                    type: 'information',
                }
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.ConfirmModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Object) => {
                    modalElem.hide();
                    if (result) {
                        const res: any = this.digiconService.startKit(digicon.kit);
                        console.log("res startKit: ", res);
                        Common.Utils.alertOnSuccess(`Kit started succesfully`, 'bottom-center');
                    }
                });
            });
        }

        private async stopKit(digicon: IDigicon):Promise<void>{

            this.modalService.showModal({
                templateUrl: Controllers.ConfirmModalController.templateURL,
                controller: Controllers.ConfirmModalController.$name,
                inputs: {
                    title: 'STOP KIT',
                    description: "Kit will be stopped",
                    name: digicon.kit,
                    type: 'information',
                }
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.ConfirmModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Object) => {
                    modalElem.hide();
                    if (result) {
                        const res: any = this.digiconService.stopKit(digicon.kit);
                        console.log("res startKit: ", res);
                        Common.Utils.alertOnSuccess(res.status, 'bottom-center');
                    }
                });
            });
        }

        private showErrorModal(title: string, description: string): void {
            this.modalService.showModal({
                templateUrl: Controllers.ErrorModalController.templateURL,
                controller: Controllers.ErrorModalController.$name,
                inputs: {
                    title,
                    description,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.ErrorModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Object) => {
                    modalElem.hide();
                });
            });
        }

        /**
         * check if node is being used, if not, delete Node from inventory.
         * @param node node to be deleted
         */
        public async deleteNodeModal(node: INetworkNode): Promise<void> {
            let usingBlocks = await this.streamPipeService.isInUse(this.getBlocksIdListFromNode(node.blocks).join('-'));
            if (usingBlocks === true) {
                this.errorDeleteNode();
                return;
            }
            this.modalService.showModal({
                templateUrl: Controllers.ConfirmModalController.templateURL,
                controller: Controllers.ConfirmModalController.$name,
                inputs: {
                    title: 'DELETE NODE',
                    description: "This action cannot be undone.",
                    name: node.name,
                    type: 'warning',
                }
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.ConfirmModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Object) => {
                    modalElem.hide();
                    if (result) {
                        $('#saving-spinner').css({display: 'block'});
                        this.networkNodeService.deleteNetworkNode(node).then(() => {
                            this.blockService.deleteRedundantGroups(node);
                            $('#saving-spinner').css({display: 'none'});
                        });
                        this.initNetworkNodes();
                    }
                });
            });
        }

        /**
         * show modal to inform that node is being used and cannot be removed from inventory
         * @param node
         */
        public async errorDeleteNode(): Promise<void> {
            this.modalService.showModal({
                templateUrl: Controllers.InfoModalController.templateURL,
                controller: Controllers.InfoModalController.$name,
                inputs: {
                    title: 'ERROR DELETING NODE',
                    description: 'Device cannot be deleted. Stop every transmission that this device is part of and try again.',
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.InfoModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Object) => {
                    modalElem.hide();
                });
            });
        }
        /**
         * given an array of blocks, return an array of block id's of this Node.
         * @param blocks blocks to remove id's from
         */
        public getBlocksIdListFromNode(blocks: Block[]): number[]{
            let aux = [];
            return  aux = blocks.map((block) => {
                return block.id;
            });
        }


        public deleteElementModal(element: Models.ITopologyElement): void {
            this.modalService
                .showModal({
                    templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                    controller: Application.Controllers.ConfirmModalController.$name,
                    inputs: {
                        title: 'DELETE '
                            .concat(Models.TopologyElement
                                .getElementTypeAsString((element as Models.ITopologyElement))
                                .toUpperCase()),
                        description: "This action cannot be undone.",
                        name: (element as Models.ITopologyElement).name,
                        type: 'information',
                    },
                })
                .then((modal: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement =
                        UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                            {bgclose: false, modal: false, keyboard: false});
                    modalElem.show();
                    modal.close.then((result: Object) => {
                        modalElem.hide();
                        if (result) {
                            let typeToDelete: Models.TopologyElementType = (element as Models.ITopologyElement).class();
                            $('#saving-spinner').css({display: 'block'});
                            switch (typeToDelete) {
                                case Models.TopologyElementType.Gateway:
                                    this.gatewayService.deleteGateway( element as Models.IGateway ).then(() => {
                                        this.updateGateway(element as Models.IGateway, true);
                                        $('#saving-spinner').css({display: 'none'});
                                    });
                                    break;

                                case Models.TopologyElementType.Network:
                                case Models.TopologyElementType.SonNetwork:
                                    this.networkService.deleteNetwork( element as Models.INetwork ).then(() => {
                                        this.updateNetwork(element as Models.INetwork, true);
                                        $('#saving-spinner').css({display: 'none'});
                                    });
                                    break;
                                default:
                                    // nothing
                            }
                        }
                    });
                });

        }

        public deleteDigiconModal(element: Models.IDigicon): void {
            this.modalService
                .showModal({
                    templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                    controller: Application.Controllers.ConfirmModalController.$name,
                    inputs: {
                        title: 'DELETE ',
                        description: "This action cannot be undone.",
                        name: element.kit,
                        type: 'information',
                    },
                })
                .then((modal: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement =
                        UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                            {bgclose: false, modal: false, keyboard: false});
                    modalElem.show();
                    modal.close.then((result: Object) => {
                        modalElem.hide();
                        if (result) {
                            $('#saving-spinner').css({display: 'block'});
                            this.digiconService.deleteDigicon(element).then(() => {
                                $('#saving-spinner').css({display: 'none'});
                                this.loadDigicons();
                            }).catch((reason: ngCustom.IReason) => {
                                $('#saving-spinner').css({display: 'none'});
                                this.showErrorModal('Error updating digicon', 'kit is in use or gateways already exists.');
                            });
                        }
                    });
                });
        }

        public applyDigiconsModal(): void {
            this.modalService
                .showModal({
                    templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                    controller: Application.Controllers.ConfirmModalController.$name,
                    inputs: {
                        title: 'APPLY DIGICONS ',
                        description: "Do you want to apply the digicons?.",
                        name: "apply",
                        type: 'information',
                    },
                })
                .then((modal: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement =
                        UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                            {bgclose: false, modal: false, keyboard: false});
                    modalElem.show();
                    modal.close.then((result: Object) => {
                        modalElem.hide();
                        if (result) {
                            $('#saving-spinner').css({display: 'block'});
                            this.digiconService.applyDigicons().then(() => {
                                Common.Utils.alertOnSuccess(`status: "Matchday Applied"`, 'bottom-center');
                                $('#saving-spinner').css({display: 'none'});
                                this.loadDigicons();
                            }).catch((reason: ngCustom.IReason) => {
                                $('#saving-spinner').css({display: 'none'});
                                this.showErrorModal('Error applying digicons', 'error applying digicons.');
                            });
                        }
                    });
                });
        }

        public editPermissions(element: NetworkNode | Gateway | Network): void {
            let typeName: string = Models.topologyElementTypeToHref[element.class()];
            this.modalService.showModal({
                templateUrl: Controllers.AclModalController.templateURL,
                controller: Controllers.AclModalController.$name,
                inputs: {
                    entity: element,
                    entityTypeName: typeName,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.AclModalController.ID,
                            {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then(() => {
                    modalElem.hide();
                });
            });
        }

        public usedBlocks(networkNode: NetworkNode): void {
            this.modalService.showModal({
                templateUrl: Application.Controllers.UsedBlocksController.templateURL,
                controller: Application.Controllers.UsedBlocksController.$name,
                inputs: {
                    entity: networkNode,
                    entityTypeName: 'networkNodes',
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.UsedBlocksController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then(() => {
                    modalElem.hide();
                });
            });
        }

        public editVNOs(element: (NetworkNode | Gateway | Network) & IExtendedInvetoryElement): void {
            let otherVnos: IVno[] = this.vnos.filter((vno: IVno) => element.evaluatedPermissions.organizations.indexOf(vno.id) < 0);
            let vnosWithoutEbu: IVno[] = element.vnos.filter((nodeVno: IVno) => nodeVno.id !== 1);
            this.modalService.showModal({
                templateUrl: Controllers.DualListModalController.templateUrl,
                controller: Controllers.DualListModalController.$name,
                inputs: {
                    title: `Manage VNOs for ${element.name}`,
                    titleElements: `Rest of VNOs`,
                    titleSelectedElements: `VNOs with permission`,
                    firstColumn: undefined,
                    secondColumn: undefined,
                    elements:  otherVnos,
                    selectedElements: vnosWithoutEbu,
                    idProperty: 'id',
                    nameProperty: 'name',
                    secondColumnProperty: undefined,
                    noMoreToAddText: 'No VNOs to add',
                    noneSelectedText: 'No VNOs selected',
                    secondaryInfoCompare: undefined,
                    highlightedId: undefined,
                    type: Controllers.DualListModalController.vnoType,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.DualListModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: {selected: IVno[], unselected: IVno[]}) => {
                    if (result) {
                        element.evaluatedPermissions.organizations = result.selected.map((vnoSelected: IVno) => vnoSelected.id );
                        element.evaluatedPermissions.organizations.push(1); // ebu vno
                        this.getChangeOrganizationsPromise(element).then(() => {
                            this.setElementVnos(element);
                            Common.Utils.alertOnSuccess(`Permissions changed succesfully`, 'bottom-center');
                        });
                    }
                    modalElem.hide();
                });
            });
        }

        public loadAllNodes(): void {
            this.loadMore().then( () => {
                if (this.moreData)
                    this.loadAllNodes();
            });
        }

        public loadMore(): ng.IPromise<void> {
            this.dataLoaded = false;
            this.addedNodes = [];
            let pageSizeToRequest: number = AdminInventoryController.NUM_REQUESTS;
            this.currentPage++;
            return this.loadNetworkNodesWithPageSize(pageSizeToRequest, this.currentPage);
        }

        public maintenanceChanged(node: NetworkNode & IExtendedInvetoryElement): void {
            this.networkNodeService.updateWorkflowMode(node)
                .then(() => {
                    node.workflowMode = node.isMaintenance ? "maintenance" : 'operation';
                })
                .catch((reason: ngCustom.IReason) => {
                    if (reason.status === 412) {
                        if (node.isMaintenance)
                            this.maintenanceModeErrorModal(node);
                    }
                });
        }

        public showModalError(title: string, description: string): void {
            this.modalService.showModal({
                templateUrl: Controllers.InfoModalController.templateURL,
                controller: Controllers.InfoModalController.$name,
                inputs: {
                    title: title,
                    description: description,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.InfoModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Object) => {
                    modalElem.hide();
                });
            });
        }

        public maintenanceModeErrorModal(networkNode: INetworkNode): void {
            networkNode.isMaintenance = false;
            this.showModalError('MAINTENANCE MODE',
                this.messageTranslationsService.getMessageAsStringByKeySync("networknodes.setmaintenance.transmitting"));
        }

        public regenerateBlocks(networkNode: Models.NetworkNode): void {
            this.blockService.regenerateBlocks(Common.Utils.idFromHref(networkNode.href)).then(() => {
                this.setBlocksToShow(networkNode);
            });
        }

        public mgmtServersFromNode(networkNode: Models.NetworkNode): Promise<Models.IMgmtServer[]> {
            return this.networkNodeService.getMgmtServers(networkNode);
        }

        public changeMgmtServer(node: Models.NetworkNode, index: number, event: Event): void {
            node.mgmtServers.forEach((server: Models.IMgmtServer) => {
                if (server.index === index)
                    server.changing = true;
                else
                    server.selected = false;
            });
            this.networkNodeService.setMgmtServers(node, index).then((result: boolean) => {
                if (result)
                    this.reloadMgmtServers(node, index);
            });
            event.stopPropagation();
        }

        private handlerSaveNodeTask (result:any[]): void {
            let success = result.filter(x => x.id);
            let failedMsgs = result
                .filter(x => x.status && x.status !== 200)
                .map(x => {
                    let errorMsg: string = x;
                    let nodeName: string = "Unexpected";
                    if (x.data && x.data.message) {
                        errorMsg = x.data.message;
                        if (errorMsg.indexOf(this.SERIAL_NUMBER_ERROR) > -1)
                            errorMsg = "Serial number in file already exists in Flex instance";
                    }

                    if (x.config && x.config.data.name)
                        nodeName = x.config.data.name;

                    return nodeName + " " + errorMsg + "<br/>";
                });

            this.showModalError("Nodes Imported ",
                "Nodes successfully imported: " + success.length +
                " Failed: " + (result.length - success.length));

            if (failedMsgs.length > 0)
                console.log("Error Details when importing:\n" + failedMsgs.join("\n"));

            if (success.length > 0) {
                this.sortReverse = 'ASC';
                this.sortColumn('lastUpdateDate');
            }
        }

        /**
         * It does the transformation required to export a node: remove properties not used, change names, remove vnos, connections,...
         */
        private async transformNodeToExport(n: INetworkNodeExtended): Promise<INetworkNodeExtended> {

            let result = {...n}; // spread, shallow copy

            // blocks are required to get the configuration, then init configuration is replaced with updated information.
            // I.e. IPs for vts blocks, etc,..
            let blocks: Models.IBlock[] = await this.blockService.blocksInNode(Common.Utils.idFromHref(n.href), false);

            const typeId: string = '' + result.type.id;
            const name: string = result.alias ? result.alias : result.name;

            let blockNameParameters: IBlockNameParameters = {
                nodeName: name,
                numberOfBlocks: blocks[blocks.length-1] ? blocks[blocks.length-1].config.index : 0,
            }

            if (n.type.isSrt) {
                blockNameParameters.cpus = n.config.cpus;
                blockNameParameters.cpusOffset = n.config.cpusOffset;
            }

            let generatedBlockNames: IBlockName[] = await this.blockService.getDefaultBlocksNamesWithParameters(typeId, blockNameParameters);
            generatedBlockNames = generatedBlockNames.filter( (b) => b.naturalKey !== BlockTypeNaturalKey.MVP_SERVER);

            const isIO = n.type.name === NetworkNodeType.FLEX_IO;
            if (result.config && generatedBlockNames) {
                generatedBlockNames = generatedBlockNames.filter((gb: IBlockName) => blocks.filter(b =>  (b.config && b.config.index === gb.appIndex ))[0] !== undefined);
                let appIndex = 1;
                generatedBlockNames.map( (gb: IBlockName, i: number) => {
                    let block: IBlock = blocks.filter(b =>  (b.config && b.config.index === gb.appIndex && b.blockTypeNaturalKey === gb.naturalKey))[0];
                    gb.name = block.name;
                    gb.suffix = block.suffix;
                    if (block.config.redundancyGroup) {
                        delete block.config.redundancyGroup;
                        delete block.config.redundancyConnection;
                    }
                    gb.configAsJsonString = JSON.stringify(block.config);
                    gb.blockIndex = isIO ? 0 : i;
                    gb.appIndex = appIndex;
                    if (!isIO) {
                        appIndex++;
                    }
                });
            };

            result.deviceCredentials = await this.deviceCredentialsService.getDeviceCredentialsFor(n);

            result.config.blockNames.generatedBlockNames = generatedBlockNames;
            result.config.numberOfBlocks = generatedBlockNames.length;
            if (isIO) {
                result.config.numberOfBlocks--;
            }
            result.href = "";
            result.name = "NE_" + result.name;

            // remove healthcheck informations
            if (n.health && n.health.data) {
                result.health = {...n.health};
                result.health.data = {...n.health.data};
                result.health.data.healthStatus = "PENDING";
                result.health.data.checks = [];
                result.health.data.elementId = "";
            }

            // leave only basic information of the network interface. Difficult to port to other instances
            result.networkInterfaces = n.networkInterfaces.map(ni => {
                let newNI: NetworkInterface = new NetworkInterface;
                newNI.name = ni.name;
                newNI.dhcp = ni.dhcp;
                newNI.ipAddress = ni.ipAddress;
                newNI.type = ni.type;
                return newNI;
            });

            // remove all vno information, difficult to port to other system
            result.vnos = [];

            result.geoElement = new GeoElement();
            result.geoElement.auto = true;

            // delete properties not used in creation of nodes
            delete result.evaluatedPermissions;
            delete result.blocks;
            delete result.canWrite;
            delete result.ipAddressToShow;

            return result;
        }



        private reloadMgmtServers(element: NetworkNode, newIndex: number): void {
            const [desired]: Models.IMgmtServer[] = element.mgmtServers.filter((server: Models.IMgmtServer) => server.index === newIndex);
            if (desired && !desired.selected) {
                desired.changing = true;
                this.$timeout(() => {
                    this.networkNodeService.fillMgmtServers(element).then(() => {
                        this.reloadMgmtServers(element, newIndex);
                    });
                }, 2000);
            } else {
                if (!desired) {
                    return;
                }
                this.modalService.showModal({
                    templateUrl: Controllers.InfoModalController.templateURL,
                    controller: Controllers.InfoModalController.$name,
                    inputs: {
                        title: 'MANAGEMENT SERVER CHANGED',
                        description: "Management server changed to " + desired.name,
                    },
                }).then((modal: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.InfoModalController.ID,
                        {bgclose: false, modal: false, keyboard: false});
                    modalElem.show();
                    modal.close.then((result: Object) => {
                        modalElem.hide();
                    });
                });
            }
        }

        private setNodePermissions(networkNodes: NetworkNode[]): ng.IPromise<NetworkNode[]> {
            let ids: number[] = networkNodes.map((n: INetworkNode) => {
                return Common.Utils.idFromHref(n.href);
            });
            return this.aclService.getPermissionsList('networkNodes', ids).then((evaluatedAcls: Models.IEvaluatedAcl[]) => {
                if (evaluatedAcls === undefined || evaluatedAcls.length !== networkNodes.length) {
                    for (let i: number = 0; i < networkNodes.length; i++) {
                        networkNodes[i].canWrite = false;
                    }
                } else {
                    for (let i: number = 0; i < networkNodes.length; i++) {
                        networkNodes[i].evaluatedPermissions = evaluatedAcls[i];
                        networkNodes[i].canWrite = evaluatedAcls[i].write;
                    }
                }
                return networkNodes;
            }).catch(() => {
                for (let i: number = 0; i < networkNodes.length; i++) {
                    networkNodes[i].canWrite = false;
                }
                return networkNodes;
            });
        }

        private setNetworkPermissions(networks: INetwork[]): ng.IPromise<INetwork[]> {
            let ids: number[] = networks.map((n: INetwork) => {
                return Common.Utils.idFromHref(n.href);
            });
            return this.aclService.getPermissionsList('networks', ids).then((evaluatedAcls: Models.IEvaluatedAcl[]) => {
                if (evaluatedAcls === undefined || evaluatedAcls.length !== networks.length) {
                    for (let i: number = 0; i < networks.length; i++) {
                        networks[i].canWrite = false;
                    }
                } else {
                    for (let i: number = 0; i < networks.length; i++) {
                        networks[i].canWrite = evaluatedAcls[i].write;
                        (networks[i] as (INetwork & IExtendedInvetoryElement)).evaluatedPermissions = evaluatedAcls[i];
                    }
                }
                return networks;
            }).catch(() => {
                for (let i: number = 0; i < networks.length; i++) {
                    networks[i].canWrite = false;
                }
                return networks;
            });
        }

        private setGatewayPermissions(gateways: IGateway[] ): ng.IPromise<IGateway[]> {
            let ids: number[] = gateways.map((n: IGateway) => {
                return Common.Utils.idFromHref(n.href);
            });
            return this.aclService.getPermissionsList('gateways', ids).then((evaluatedAcls: Models.IEvaluatedAcl[]) => {
                if (evaluatedAcls === undefined || evaluatedAcls.length !== gateways.length) {
                    for (let i: number = 0; i < gateways.length; i++) {
                        gateways[i].canWrite = false;
                    }
                } else {
                    for (let i: number = 0; i < gateways.length; i++) {
                        gateways[i].canWrite = evaluatedAcls[i].write;
                        (gateways[i] as (IGateway & IExtendedInvetoryElement)).evaluatedPermissions = evaluatedAcls[i];
                    }
                }
                return gateways;
            }).catch(() => {
                for (let i: number = 0; i < gateways.length; i++) {
                    gateways[i].canWrite = false;
                }
                return gateways;
            });
        }

        private setNetworkNodeExtraData(networkNode: INetworkNode): void {
            if (networkNode.ipAddressToShow === undefined || networkNode.ipAddressToShow === '')
                this.setIpAddressToShow(networkNode);
            if (networkNode.vnos === undefined || networkNode.vnos.length === 0)
                this.setElementVnos(networkNode as NetworkNode);
        }

        private setIpAddressToShow(networkNode: INetworkNode): void {
            if (networkNode.networkInterfaces.length === 1) {
                networkNode.ipAddressToShow = networkNode.networkInterfaces[0].dhcp ? 'DHCP' : networkNode.networkInterfaces[0].ipAddress;
            } else if (networkNode.networkInterfaces.length > 1) {
                networkNode.networkInterfaces.sort((a: INetworkInterface, b: INetworkInterface) => {
                    return (a.id > b.id) ? 1 : -1;
                });
                for (let nic of networkNode.networkInterfaces) {
                    if (nic.ipAddress && nic.ipAddress !== '' && nic.ipAddress !== '0.0.0.0' && !nic.dhcp) {
                        networkNode.ipAddressToShow = nic.ipAddress;
                    }
                }
                if (!networkNode.ipAddressToShow) {
                    networkNode.ipAddressToShow = networkNode.networkInterfaces[0].dhcp ?
                        'DHCP' : networkNode.networkInterfaces[0].ipAddress;
                }
            }
        }

        private setElementVnos(element: (NetworkNode | Network | Gateway) & IExtendedInvetoryElement): void {
            element.isShared = element.evaluatedPermissions.organizations.length > 2;
            element.vnos = this.vnos.filter((vno: IVno) => element.evaluatedPermissions.organizations.indexOf(vno.id) > -1);
            element.vnosToPrint = element.getVnoNames();
        }

        /**
         * Method to filter tab elements by the elements included in vnoFilterMap
         *
         * @param tabElement the element to be filtered
         * @return a list with the filtered elements or the elements without filtering if no filter to apply
         */
        private filterTabByVno(tabElement: IGatewayExtended[]): IGatewayExtended[]
        private filterTabByVno(tabElement: INetworkExtended[]): INetworkExtended[]
        private filterTabByVno(tabElement: Array<IGatewayExtended | INetworkExtended>): Array<IGatewayExtended | INetworkExtended> {
            const vnoFilteredNames: string[] = this.getFilteredVnoNames();
            if (vnoFilteredNames && vnoFilteredNames.length > 0) {
                return tabElement
                    .filter(element => {
                        const filtered: IVno[] = element.vnos.filter((vno: IVno) => this.vnoFilterMap[vno.name]);
                        return filtered.length > 0;
                    });
            }
            return tabElement;
        }

        private getFilteredStatus(): string[] {
            return Object.keys(this.statusFilterMap).filter((status: string) => {
                return this.statusFilterMap[status] === true;
            }).map((status: string) => {
                return status;
            });
        }

        private getFilteredMaintenance(): string[] {
            return Object.keys(this.maintenanceFilterMap).filter((status: string) => {
                return this.maintenanceFilterMap[status] === true;
            }).map((status: string) => {
                return status;
            });
        }

        private getFilteredTypes(): number[] {
            return this.networkNodeTypes
                .filter((type: NetworkNodeType) => this.typeFilterMap[type.name])
                .map((type: NetworkNodeType) => Common.Utils.idFromHref(type.href));
        }

        private getFilteredVnos(): number[] {
            return this.vnos
                .filter((vno: IVno) => this.vnoFilterMap[vno.name])
                .map((vno: IVno) => vno.id);
        }

        /**
         * Method to get the VNOs name filtered by the elements included in vnoFilterMap
         *
         * @return string[] with the filtered VNO names
         */
        private getFilteredVnoNames(): string[] {
            return this.vnos
                .filter((vno: IVno) => this.vnoFilterMap[vno.name])
                .map((vno: IVno) => vno.name);
        }

        private getFilteredDigiconMatchDays(): string[] {
            return Object.keys(this.digiconMatchDayFilterMap).filter((status: string) => {
                return this.digiconMatchDayFilterMap[status] === true;
            }).map((status: string) => {
                return status;
            });
        }

        private getFilteredDigiconMatchNumbers(): string[] {
            return Object.keys(this.digiconMatchNumberFilterMap).filter((status: string) => {
                return this.digiconMatchNumberFilterMap[status] === true;
            }).map((status: string) => {
                return status;
            });
        }

        private getFilteredDigiconStatus(): string[] {
            return Object.keys(this.digiconStatusFilterMap).filter((status: string) => {
                return this.digiconStatusFilterMap[status] === true;
            }).map((status: string) => {
                return status;
            });
        }

        private getFilteredDigiconPorts(): string[] {
            return Object.keys(this.digiconPortFilterMap).filter((status: string) => {
                return this.digiconPortFilterMap[status] === true;
            }).map((status: string) => {
                return status;
            });
        }

        private getFilteredDigiconRoles(): string[] {
            return Object.keys(this.digiconRoleFilterMap).filter((status: string) => {
                return this.digiconRoleFilterMap[status] === true;
            }).map((status: string) => {
                return status;
            });
        }

        private getFilteredDigiconModes(): string[] {
            return Object.keys(this.digiconModeFilterMap).filter((status: string) => {
                return this.digiconModeFilterMap[status] === true;
            }).map((status: string) => {
                return status;
            });
        }

        private getFilteredDigiconMainGateways(): string[] {
            return Object.keys(this.digiconMainGatewayFilterMap).filter((status: string) => {
                return this.digiconMainGatewayFilterMap[status] === true;
            }).map((status: string) => {
                return status;
            });
        }

        private getFilteredDigiconBackupGateways(): string[] {
            return Object.keys(this.digiconBackupGatewayFilterMap).filter((status: string) => {
                return this.digiconBackupGatewayFilterMap[status] === true;
            }).map((status: string) => {
                return status;
            });
        }

        private getFilteredDigiconKits(): string[] {
            return Object.keys(this.digiconKitsFilterMap).filter((status: string) => {
                return this.digiconKitsFilterMap[status] === true;
            }).map((status: string) => {
                return status;
            });
        }

        private loadNetworkNodes(): ng.IPromise<void> {
            this.dataLoaded = false;
            let pageSizeToRequest: number = AdminInventoryController.NUM_REQUESTS;
            return this.loadNetworkNodesWithPageSize(pageSizeToRequest, this.currentPage);
        }

        private loadNetworkNodesWithPageSize(pageSizeToRequest: number, pageNumber: number): ng.IPromise<void> {
            this.nodesRepo.loading = true;
            return this.networkNodeService.getFilteredNetworkNodes(pageNumber, pageSizeToRequest,
                this.sortType, this.sortReverse, this.searchText,
                this.getFilteredTypes(), this.getFilteredVnos(), this.getFilteredStatus(), this.getFilteredMaintenance())
                .then((networkNodes: IPaginatedList<NetworkNode>) => {

                    networkNodes.elements = networkNodes.elements.filter((node: INetworkNode) => {
                        return node.type.name !== undefined && node.type.name !== '';
                    });

                    this.setNodePermissions(networkNodes.elements).then((n: NetworkNode[]) => {
                        networkNodes.elements = n;
                        this.updateBlocksToShow(networkNodes.elements);
                        if (!this.networkNodes || this.networkNodes.length === 0) {
                            this.networkNodes = networkNodes.elements;
                        } else {
                            networkNodes.elements.forEach((node: NetworkNode) => {
                                let found: INetworkNode[] = this.networkNodes.filter((networkNode: INetworkNode) => {
                                    return networkNode.href === node.href;
                                });
                                if (found.length === 0) {
                                    this.networkNodes.push(node);
                                }
                            });
                        }
                        this.networkNodes.forEach((networkNode: INetworkNode) => {
                            this.setIpAddressToShow(networkNode);
                        });

                        this.networkNodes.forEach((networkNode: NetworkNode) => {
                            if (networkNode.type.vendor === Models.NetworkNodeTypeVendor.MVP && !networkNode.isMaintenance) {
                                this.networkNodeService.fillMgmtServers(networkNode);
                            }
                        });

                        for (let nn of this.networkNodes) {
                            this.setNetworkNodeExtraData(nn);
                        }
                    });

                    if (networkNodes.page.totalPages > (pageNumber + 1)) {
                        this.moreData = true;
                    } else {
                        this.moreData = false;
                    }

                    this.dataLoaded = true;
                    this.nodesRepo.loading = false;
                    this.nodesRepo.totalLoaded = this.networkNodes ? this.networkNodes.length : 0;
                });
        }

        private loadGateways(): void {
            this.gatewayService.getAllGatewaysPromise().then((gateways: Gateway[]) => {
                this.setGatewayPermissions(gateways).then((g: Gateway[]) => {
                    this.gateways = gateways;
                    this.gateways.forEach((gateway: Gateway & IExtendedInvetoryElement) => this.setElementVnos(gateway));
                    this.gateways = this.filterTabByVno(this.gateways) as (IGateway & IExtendedInvetoryElement)[];
                });
            });
        }

        private loadDigicons(): void {
            this.digiconService.getAllDigiconsFilteredPromise(this.getFilteredDigiconStatus(), this.getFilteredDigiconMatchDays(),
                this.getFilteredDigiconMatchNumbers(), this.getFilteredDigiconKits(), this.getFilteredDigiconModes(),
                this.getFilteredDigiconPorts(), this.getFilteredDigiconRoles(), this.getFilteredDigiconMainGateways(),
                this.getFilteredDigiconBackupGateways()).then((digicons: Digicon[]) => {

                    this.digicons = digicons;
                    this.digiconsReady = true;
                    this.loadKitStatus();
                }).catch((reason: ngCustom.IReason) => {
                    this.digiconsReady = true;
                    $('#saving-spinner').css({display: 'none'});
                    this.showErrorModal('Error loading digicons', 'Digicons cannot be loaded.');
                });
        }

        private loadKitStatus(): void {
            this.digicons.forEach((digicon: Digicon, index: number) => {
                this.digiconService.kitStatus(digicon.kit).then((kit: IKit) => {
                    digicon.status = kit.status;
                });
            });

        }

        private loadNetworks(): void {
            this.networkService.getAllNetworksPromise().then((networks: INetwork[]) => {
                this.networks = networks.filter((network: INetwork) => network.type !== "INTERNET");
                this.setNetworkPermissions(this.networks).then(() => {
                    this.networks.forEach((network: Network & IExtendedInvetoryElement) => this.setElementVnos(network));
                    this.networks = this.filterTabByVno(this.networks) as (INetwork & IExtendedInvetoryElement)[];
                });
            });
        }

        private updateNetworkNode(flexEvent: IFlexEvent, href: string): ng.IPromise<NetworkNode> {
            let modifiedNetworkNode: NetworkNode = NetworkNode.Copy(flexEvent.data);
            modifiedNetworkNode.href = href;
            modifiedNetworkNode.health = this.healthService.getNodeHealth(modifiedNetworkNode.href);
            modifiedNetworkNode.isMaintenance = modifiedNetworkNode.workflowMode === 'maintenance';
            return this.networkNodeTypeService.findById(Number(modifiedNetworkNode.typeId)).then((type: NetworkNodeType) => {
                modifiedNetworkNode.type = type;
                return this.setNodePermissions([modifiedNetworkNode]).then(() => {
                    this.setBlocksToShow(modifiedNetworkNode as NetworkNode);
                    this.setNetworkNodeExtraData(modifiedNetworkNode);
                    return modifiedNetworkNode;
                });
            });
        }

        private updateAddedNodes(flexEvent: IFlexEvent, id: number): void {
            this.addedNodes.forEach((addedNode: INetworkNode, index: number) => {
                if (id === Common.Utils.idFromHref(addedNode.href)) {
                    this.updateNetworkNode(flexEvent, addedNode.href).then((modifiedNetworkNode: NetworkNode) => {
                            this.addedNodes[index] = modifiedNetworkNode;
                    });
                }
            });
        }

        private loadFilterTypeMap(): void {
            this.typeFilterMap = {};
            this.networkNodeTypes.forEach((nodeType: NetworkNodeType) => {
                this.typeFilterMap[nodeType.name] = false;
            });
        }

        private loadStatusFilterMap(): void {
            this.statusFilterMap = {};
            let online: string = "ONLINE";
            let offline: string = "OFFLINE";
            this.statusFilterMap[online] = false;
            this.statusFilterMap[offline] = false;
        }

        private loadDigiconMatchDayFilterMap(): void {
            this.digiconMatchDayFilterMap = {};
            let tuesday: string = "Tuesday";
            let wednesday: string = "Wednesday";
            this.digiconMatchDayFilterMap[tuesday] = false;
            this.digiconMatchDayFilterMap[wednesday] = false;
        }

        private loadDigiconPortFilterMap(): void {
            this.digiconPortFilterMap = {};
            let t1e: string = "Telco 1 Electrical";
            let t1o: string = "Telco 1 Optical";
            let t2e: string = "Telco 2 Electrical";
            let t2o: string = "Telco 2 Optical";
            this.digiconPortFilterMap[t1e] = false;
            this.digiconPortFilterMap[t1o] = false;
            this.digiconPortFilterMap[t2e] = false;
            this.digiconPortFilterMap[t2o] = false;
        }

        private loadDigiconMatchNumberFilterMap(): void {
            this.digiconMatchNumberFilterMap = {};
            let matchNumber1: string = "1";
            let matchNumber2: string = "2";
            let matchNumber3: string = "3";
            let matchNumber4: string = "4";
            let matchNumber5: string = "5";
            let matchNumber6: string = "6";
            let matchNumber7: string = "7";
            let matchNumber8: string = "8";
            this.digiconMatchNumberFilterMap[matchNumber1] = false;
            this.digiconMatchNumberFilterMap[matchNumber2] = false;
            this.digiconMatchNumberFilterMap[matchNumber3] = false;
            this.digiconMatchNumberFilterMap[matchNumber4] = false;
            this.digiconMatchNumberFilterMap[matchNumber5] = false;
            this.digiconMatchNumberFilterMap[matchNumber6] = false;
            this.digiconMatchNumberFilterMap[matchNumber7] = false;
            this.digiconMatchNumberFilterMap[matchNumber8] = false;
        }

        private loadDigiconRoleFilterMap(): void {
            this.digiconRoleFilterMap = {};
            let main: string = "Main";
            let backup: string = "Backup";
            this.digiconRoleFilterMap[main] = false;
            this.digiconRoleFilterMap[backup] = false;
        }

        private loadDigiconModeFilterMap(): void {
            this.digiconModeFilterMap = {};
            let fiber: string = "Fiber";
            let satellite: string = "Satellite";
            this.digiconModeFilterMap[fiber] = false;
            this.digiconModeFilterMap[satellite] = false;
        }

        private async loadDigiconMainGatewayFilterMap(): Promise<void> {
            let mainGateways: String[] = await this.digiconService.getMainGatewaysPromise();
            this.digiconMainGatewayFilterMap = {};
            mainGateways.forEach((gateway: string) => {
                this.digiconMainGatewayFilterMap[gateway] = false;
            });
        }

        private async loadDigiconBackupGatewayFilterMap(): Promise<void> {
            let mainGateways: String[] = await this.digiconService.getBackupGatewaysPromise();
            this.digiconBackupGatewayFilterMap = {};
            mainGateways.forEach((gateway: string) => {
                this.digiconBackupGatewayFilterMap[gateway] = false;
            });
        }

        private async loadDigiconKitsFilterMap(): Promise<void> {
            let mainGateways: String[] = await this.digiconService.getKits();
            this.digiconKitsFilterMap = {};
            mainGateways.forEach((kit: string) => {
                this.digiconKitsFilterMap[kit] = false;
            });
        }

        private async loadDigiconStatusFilterMap(): Promise<void> {
            this.digiconStatusFilterMap = {};
            let init: string = "initial";
            let running: string = "running";
            let error: string = "error";
            let outofsync: string = "out of sync";
            let standby: string = "standby";

            this.digiconStatusFilterMap[init] = false;
            this.digiconStatusFilterMap[running] = false;
            this.digiconStatusFilterMap[error] = false;
            this.digiconStatusFilterMap[outofsync] = false;
            this.digiconStatusFilterMap[standby] = false;
        }

        private loadMaintenanceFilterMap(): void {
            this.maintenanceFilterMap = {};
            let operation: string = this.operationFilterName;
            let maintenance: string = this.maintenanceFilterName;
            this.maintenanceFilterMap[operation] = false;
            this.maintenanceFilterMap[maintenance] = false;
        }

        private loadFilterVnoMap(): void {
            this.vnoFilterMap = {};
            this.vnos.forEach((vno: IVno) => {
                this.vnoFilterMap[vno.name] = false;
            });
        }

        /**
         * Initialize methods
         */
        private async initData(): Promise<void> {
            this.vnos = await this.vnoService.findAll();
            this.loadStatusFilterMap();
            this.loadFilterVnoMap();
            switch (this.nodeType) {
                case 'devices':
                    this.initNetworkNodes();
                    break;
                case 'networks':
                    this.loadNetworks();
                    break;
                case 'gateways':
                    this.loadGateways();
                    break;
                case 'digicon':
                    this.loadDigiconMatchDayFilterMap();
                    this.loadDigiconPortFilterMap();
                    this.loadDigiconStatusFilterMap();
                    this.loadDigiconModeFilterMap();
                    this.loadDigiconRoleFilterMap();
                    this.loadDigiconMatchNumberFilterMap();
                    try {
                        await this.loadDigiconKitsFilterMap();
                        await this.loadDigiconMainGatewayFilterMap();
                        await this.loadDigiconBackupGatewayFilterMap();
                    } catch (err) {
                        this.digiconsReady = true;
                        $('#saving-spinner').css({display: 'none'});
                        this.showErrorModal('Error loading digicons', 'Digicons cannot be loaded.');
                    }


                    await this.loadDigicons();
                    this.digiconInterval = this.$interval(() => {
                        if (this.digicons.length > 0) {
                            this.loadKitStatus();
                        }
                    }, this.DIGICON_INTERVAL);

                    break;
                default:
                    break;
            }
        }

        private async initNetworkNodes(): Promise<void> {
            this.loadMags();
            this.networkNodeTypes = await this.networkNodeTypeService.getAllNetworkNodeTypes();
            this.loadFilterTypeMap();
            this.loadFilterVnoMap();
            this.loadMaintenanceFilterMap();
            this.dataLoaded = false;
            await this.loadNetworkNodesWithPageSize(AdminInventoryController.NUM_REQUESTS, this.currentPage);
            this.nodesRepo.firstLoadFinished = true;
            this.launchScrollEvent();
        }
            
        private initVariables(): Promise<Models.User> {
            this.searchText = "";
            this.findSrtText = "";
            this.sortType = NetworkNode.getDefaultOrderColumn();
            this.sortReverse = 'ASC';
            this.moreDataLoaded = true;
            this.currentPage = 0;
            this.addedNodes = [];

            this.userIsAdmin = false;
            this.isDemiurgo = false;

            this.networkNodeService.getAllPaginatedNetworkNodesPromise(null, 9999).then((nodes) => { 
                this.allSrtNetworkNodes = nodes.elements.filter((node: INetworkNode) => { 
                    return node.type.name.indexOf("SRT") !== -1;
                });

                this.updateBlocksToShow(this.allSrtNetworkNodes);
                this.$timeout(() => {this.srtLoaded = true; }, 2000);
            });


            return this.userService.loadCurrentUser().then((user: Models.User) => {
                this.currentUser = user;
                this.userIsAdmin = user.authorities.some((auth: Models.IAuthority) => {
                    return auth.authority === 'ROLE_ADMIN';
                });
                this.isDemiurgo = this.userIsAdmin && user.username === 'demiurgo';
                return user;
            });

            
        }

        private initSubscriptions(): void {
            this.$scope.$on("$destroy", () => {
                this.$interval.cancel(this.digiconInterval);
                if (this.subscription)
                    this.stompService.unregister(this.subscription);
                angular.element(this.$window).unbind('scroll');
            });
            if (this.subscription)
                this.stompService.unregister(this.subscription);
            this.subscription =
                this.stompService.register(Models.NETWORK_NODES_COMPONENT, Models.ALL_OPERATIONS, (flexEvent: IFlexEvent) => {
                    this.messageReceived(flexEvent);
                });
        }

        private loadMags(): void {
            this.networkNodeService.getAllByNetworkNodeTypeId(Models.MAG_NETWORK_NODE_TYPE).then((mags: Models.NetworkNode[]) => {
                this.mags = mags;
            });
        }

        private messageReceived(flexEvent: IFlexEvent): void {
            let nodeId: number = flexEvent.data.id;
            if (flexEvent.operation === Models.DELETE_NETWORK_NODE_OPERATION) {
                this.networkNodes.forEach((node: INetworkNode, index: number) => {
                    if (Common.Utils.idFromHref(node.href) === nodeId) {
                        this.networkNodes.splice(index, 1);
                    }
                });
                this.addedNodes.forEach((node: INetworkNode, index: number) => {
                    if (Common.Utils.idFromHref(node.href) === nodeId) {
                        this.addedNodes.splice(index, 1);
                    }
                });
            } else if (flexEvent.operation === Models.SAVE_NETWORK_NODE_OPERATION) {
                if (this.addedNodes.length > 0) {
                    this.updateAddedNodes(flexEvent, nodeId);
                } else {
                    this.networkNodes.forEach((node: INetworkNode, index: number) => {
                        if (Common.Utils.idFromHref(node.href) === nodeId) {
                            this.updateNetworkNode(flexEvent, node.href)
                                .then((modifiedNetworkNode: NetworkNode) => {
                                    let canWrite: boolean = this.networkNodes[index].canWrite;
                                    this.networkNodes[index] = modifiedNetworkNode;
                                    this.networkNodes[index].canWrite = canWrite;
                                });
                        }
                    });
                }
            }
            this.loadMags();
        }

        private updateNetwork( updatedNetwork: INetwork, deleted: boolean = false ): void {
            let id: number = Common.Utils.idFromHref(updatedNetwork.href);
            this.networks.forEach((network: INetwork, index: number) => {
                if (Common.Utils.idFromHref(network.href) === id) {
                    if (deleted) {
                        this.networks.splice(index, 1);
                    } else {
                        this.networks[index] = updatedNetwork;
                    }
                }
            });
        }

        private updateGateway( updatedGateway: IGateway, deleted: boolean = false ): void {
            let id: number = Common.Utils.idFromHref(updatedGateway.href);
            this.gateways.forEach((gateway: IGateway, index: number) => {
                if (Common.Utils.idFromHref(gateway.href) === id) {
                    if (deleted) {
                        this.gateways.splice(index, 1);
                    } else {
                        this.gateways[index] = updatedGateway;
                    }
                }
            });
        }

        private launchScrollEvent(): void {
            angular.element(this.$window).bind('scroll', () => {
                if (this.moreData && !this.nodesRepo.loading &&
                    (this.$window.innerHeight + this.$window.scrollY) >= (document.body.scrollHeight - 100)) {
                        this.nodesRepo.loading = true;
                        this.loadMore().then(() => {
                            this.nodesRepo.loading = false;
                        });
                }
            });
        }

        private updateBlocksToShow(networkNodes: NetworkNode[]) {
            this.$timeout(() => {
                for (let networkNode of networkNodes) {
                        this.setBlocksToShow(networkNode);
                }
                this.srtLoaded = true;
            }, 2000);
        }

        private setBlocksToShow(networkNode: NetworkNode): void {
            this.blockService.blocksInNode(Common.Utils.idFromHref(networkNode.href)).then(
                (blocks: Models.IBlock[]) => {
                    networkNode.blocks = blocks.sort((a: Models.IBlock, b: Models.IBlock) => a.id - b.id);
                }).catch((reason: ngCustom.IReason) => {
                    this.messageTranslationsService.showPromiseError(reason);
                });
        }

        private findNetworkNodeIndexByHref(href: string, nodes: INetworkNode[] = this.networkNodes): number {
            for (let i: number = 0; i < nodes.length; i++) {
                if (nodes[i].href === href) {
                    return i;
                }
            }
            return undefined;
        }

        private getChangeOrganizationsPromise(element: (NetworkNode | Gateway | Network) & IExtendedInvetoryElement): ng.IPromise<boolean> {
            let promise: ng.IPromise<boolean>;
            switch (element.class()) {
                case Models.TopologyElementType.NetworkNode:
                    promise = this.networkNodeService
                        .changeNetworkNodeOrganizations(element.href, element.evaluatedPermissions.organizations);
                    break;
                case Models.TopologyElementType.Network:
                case Models.TopologyElementType.SonNetwork:
                    promise = this.networkService
                        .changeOrganizations(element.href, element.evaluatedPermissions.organizations);
                    break;
                case Models.TopologyElementType.Gateway:
                    promise = this.gatewayService
                        .changeOrganizations(element.href, element.evaluatedPermissions.organizations);
                    break;
                default:
                    // nothing to do
            }
            return promise;
        }
    }
}
